import Button from "@/components/Button";
import Modal from "@/components/Modal";

type ConfirmDialogProps = {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  variant?: "primary" | "danger";
  onConfirm: () => void;
  onCancel: () => void;
};

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = "Confirmar",
  variant = "primary",
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  if (!open) return null;

  return (
    <Modal open={open} onClose={onCancel} title={title}>
      <p className="mb-6 font-sans text-sm text-ink">{message}</p>
      <div className="flex items-center gap-4">
        <Button
          type="button"
          variant={variant}
          onClick={onConfirm}
          className="px-6 py-2 text-sm"
        >
          {confirmLabel}
        </Button>
        <button
          type="button"
          onClick={onCancel}
          className="font-sans text-sm text-ink/60 underline underline-offset-2 hover:text-ink"
        >
          Cancelar
        </button>
      </div>
    </Modal>
  );
}
